"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var usePersonPropertyValidator_1 = require("./usePersonPropertyValidator");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return usePersonPropertyValidator_1.default; } });
//# sourceMappingURL=index.js.map